import { PageHeader } from './PageHeader';
export default PageHeader;


// WEBPACK FOOTER //
// ./src/components/atomic/molecules/PageHeader/index.js